import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";
import { Flag } from "lucide-react";

export default function AdminReports() {
  const [reports, setReports] = useState([]);
  const load = async () => { try { const { data } = await api.get("/admin/reports"); setReports(data); } catch {} };
  useEffect(() => { load(); }, []);
  const resolve = async (id) => { await api.post(`/admin/reports/${id}/resolve`); toast.success("Report resolved."); load(); };

  return (
    <div>
      <h1 className="font-head font-black text-4xl tracking-tighter mb-1 flex items-center gap-2"><Flag className="w-7 h-7" /> Reports</h1>
      <p className="text-gray-600 font-medium mb-6">Review user reports and take action.</p>
      {reports.length === 0 ? <div className="bg-white nb-border nb-shadow p-10 text-center font-medium">No reports.</div> : (
        <div className="space-y-3">
          {reports.map((r) => (
            <div key={r.id} className="bg-white nb-border nb-shadow p-4 flex flex-wrap items-center justify-between gap-3" data-testid={`report-${r.id}`}>
              <div>
                <div className="font-head font-bold">{r.reporter_name} → reported → {r.reported_name}</div>
                <div className="text-sm text-gray-600">Reason: <span className="font-bold">{r.reason}</span>{r.details ? ` — ${r.details}` : ""}</div>
                <div className="text-xs text-gray-400">{new Date(r.created_at).toLocaleString()}</div>
              </div>
              <div className="flex items-center gap-2">
                <span className={`px-2 py-0.5 nb-border text-xs font-bold uppercase ${r.status === "open" ? "bg-[#D4AF37]" : "bg-[#10B981] text-white"}`}>{r.status}</span>
                {r.status === "open" && <button onClick={() => resolve(r.id)} data-testid={`resolve-${r.id}`} className="px-3 py-1.5 bg-black text-white nb-border text-xs font-bold uppercase nb-hover">Resolve</button>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
